import styled from "styled-components";

import { colors, radii, shadows } from "shared/ui/tokens";

import { MOBILE_BREAKPOINT } from "features/MenusList/styles";

export const Card = styled.div`
    display: flex;
    flex-direction: column;
    background: ${colors.surface};
    border-radius: ${radii.base};
    box-shadow: ${shadows.panel};
    overflow: hidden;
`;

export const Cover = styled.div`
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;
`;

export const CoverImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`;

export const CoverPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: ${colors.contentBg};
    color: ${colors.textSecondary};
    font-size: 0.75rem;

    svg {
        font-size: 48px;
        opacity: 0.5;
    }
`;

export const Logo = styled.div`
    position: absolute;
    top: 12px;
    left: 12px;
    width: 50px;
    height: 50px;
    padding: 3px;
    border-radius: 50%;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.textSecondary};

    /* contain, а не cover: логотип заведения обрезать по кругу нельзя. */
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 50%;
    }

    svg {
        font-size: 24px;
        opacity: 0.5;
    }

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        top: 8px;
        left: 8px;
        width: 40px;
        height: 40px;
        padding: 2px;

        svg {
            font-size: 20px;
        }
    }
`;

export const Body = styled.div`
    padding: 16px;
    flex: 1 1 auto;
    min-width: 0;
`;

export const Name = styled.h3`
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: ${colors.textPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Counters = styled.div`
    margin-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
    color: ${colors.textSecondary};
`;

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 16px 16px;
`;

export const Spacer = styled.div`
    flex: 1 1 auto;
`;
